var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"breadcrumb",attrs:{"to":{ name: 'group-comm-history-report' }}},[_vm._v(" Group Communication History ")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('base-page-title')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }